// Chrome banner explaining why Firefly is not in ordinary (Focus) state.
// Kept out of `ActivityDockExpandedPanel` so that file stays under the
// size budget and the tone→class map stays unit-testable via the
// pure copy helper in `fireflyStatusReason.ts`.

import type { KpiTone } from "@/components/common/kpi/kpiTypes";
import { formatFireflyStatusReasonBanner } from "./fireflyStatusReason";

function bannerClassForTone(tone: KpiTone): string {
  if (tone === "red") {
    return "border-red-300 bg-red-50 text-red-900 dark:border-red-500/60 dark:bg-red-950/40 dark:text-red-100";
  }
  if (tone === "amber") {
    return "border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-500/60 dark:bg-amber-950/40 dark:text-amber-200";
  }
  if (tone === "gold") {
    return "border-amber-200 bg-amber-50/80 text-amber-950 dark:border-amber-500/40 dark:bg-amber-950/30 dark:text-amber-100";
  }
  return "border-emerald-300 bg-emerald-50 text-emerald-900 dark:border-emerald-500/60 dark:bg-emerald-950/40 dark:text-emerald-100";
}

export type ActivityDockFireflyStatusBannerProps = {
  tone?: KpiTone | null;
  reasonLabel?: string | null;
};

export function ActivityDockFireflyStatusBanner({
  tone = null,
  reasonLabel = null,
}: ActivityDockFireflyStatusBannerProps) {
  const copy = formatFireflyStatusReasonBanner(tone, reasonLabel);
  if (!copy || !tone) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      data-firefly-status-reason="1"
      className={[
        "mb-2 rounded-md border px-2.5 py-1.5 text-[11px] font-medium",
        bannerClassForTone(tone),
      ].join(" ")}
    >
      {copy}
    </div>
  );
}
